import { render, staticRenderFns } from "./FoldingCard.vue?vue&type=template&id=23e9b933&scoped=true&"
import script from "./FoldingCard.vue?vue&type=script&lang=js&"
export * from "./FoldingCard.vue?vue&type=script&lang=js&"
import style0 from "./FoldingCard.vue?vue&type=style&index=0&id=23e9b933&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e9b933",
  null
  
)

export default component.exports